import {
  IInvite,
  CompanyInviteMetadata,
  InviteState,
  InviteRole,
  SortField,
  IInviteV2,
} from 'models/invite.model'
import { PaginatedData } from 'models/pagination.model'
import { SortOrder } from 'models/sort.model'

import api from './api'
import { IRegister } from 'models/register.model'

const sendEmailInvites = async (params: { emails: string[] }): Promise<void> => {
  await api.post('/v1/invites', params)
}

const checkInvite = async (uuid: string): Promise<IInvite> => {
  const { data } = await api.get(`/v1/invites/check/${uuid}`)
  return data
}

const getCompanyInvitedUsers = async (
  page: number,
  status: InviteState,
  companyId: string | undefined,
  sortOrder: SortOrder,
  searchEmail: string,
  sortField?: SortField,
  filterState?: string,
  role?: InviteRole,
): Promise<PaginatedData<CompanyInviteMetadata> | void> => {
  if (!companyId) return
  let query = ''
  if (status) query = query.concat(`&status=${status}`)
  if (sortField) query = query.concat(`&sortField=${sortField}`)
  if (sortOrder) query = query.concat(`&sortOrder=${sortOrder}`)
  if (searchEmail) query = query.concat(`&searchEmail=${searchEmail}`)
  if (role) query = query.concat(`&role=${role}`)
  if (filterState) query = query.concat(`&filterState=${filterState}`)

  const {
    data: { data, pagination },
  } = await api.get<PaginatedData<CompanyInviteMetadata>>(
    `/v2/company/${companyId}/invites?page=${page}${query}`,
  )

  return { data, pagination }
}

const sendEmailNotifications = async (params: {
  companyId: string
  emails: string[]
  message: string
  link: string
}): Promise<void> => {
  return api.post(`/v2/company/${params.companyId}/invites/notify`, {
    emails: params.emails,
    message: params.message,
    link: params.link,
  })
}

const checkInviteV2 = async (code: string): Promise<IInviteV2> => {
  const { data } = await api.get(`/v2/invite/check/${code}`)
  return data
}

const createCompanyOwner = async (params: {
  code: string
  cognitoId: string
  email: string
  fullname: string
  phoneNumber: string
}): Promise<IRegister> => {
  const { data } = await api.post(`/v2/invite/${params.code}/company-owner`, {
    cognitoId: params.cognitoId,
    email: params.email,
    fullname: params.fullname,
    phoneNumber: params.phoneNumber,
  })
  return data
}

const acceptInvite = async (
  code: string,
  payload: {
    fullname: string
    password: string
    passwordConfirmation: string
    phoneNumber: string
  },
) => {
  return api.post(`/v2/invite/${code}/accept`, payload)
}

const sendSingleDeepScanInvite = async (params: {
  companyId: string
  userId: string
  message: string
}): Promise<void> => {
  return api.post(`/v2/company/${params.companyId}/user/${params.userId}/invite`, {
    customMessage: params.message,
  })
}

export default {
  sendEmailInvites,
  checkInvite,
  getCompanyInvitedUsers,
  checkInviteV2,
  createCompanyOwner,
  sendEmailNotifications,
  acceptInvite,
  sendSingleDeepScanInvite,
}
